import { Autocomplete } from "@/components/Selector/Autocomplete"
import { IOption } from "@/types"
import { IBANContext, StatusType, useStatusOptions } from "@usher/pe-client-front-end-lib"
import { useContext } from "react"

interface Props {
  onChange?: (option: IOption) => void
  value?: IOption
}
export const StatusFilter = ({ value, onChange }: Props) => {
  const { currencyFilter } = useContext(IBANContext)
  const { options } = useStatusOptions({ type: StatusType.Exchange })
  const filteredOptions = options.filter((option) => {
    if (currencyFilter === "EUR") return !option.label.includes("SWIFT")
    if (currencyFilter === "USD") return !option.label.includes("SEPA")
    return true
  })
  return (
    <Autocomplete
      styles={{
        menu: (base) => ({ ...base, minWidth: 200 }),
        container: (base) => ({ ...base, minWidth: 200 }),
      }}
      value={value}
      //@ts-ignore
      onChange={onChange}
      label="Status"
      options={[{ value: "all", label: "All" }, ...filteredOptions]}
      size="sm"
    />
  )
}
